import React, { Component } from 'react';
import { connect } from 'react-redux'
import { setIsVisible } from '../../actions/message';
import Snackbar from 'material-ui/Snackbar';
import Fade from 'material-ui/transitions/Fade';

class Notifier extends Component {

  constructor(props, context) {
      super(props, context);
      this.onDismiss = this.onDismiss.bind(this);
  }

  onDismiss() {    
   
    this.props.setAlertIsVisible(false);
  }

  render() {
    const message = <div dangerouslySetInnerHTML={{ __html: this.props.message.message }} />
    return (
      <div>
      <Snackbar
          open={this.props.message.isVisible}
          message={message}
          autoHideDuration={4000}
          className='custom-snackbar'
          transition={Fade}
          onRequestClose={this.onDismiss}
           anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        />      
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setAlertIsVisible: (visible) => dispatch(setIsVisible(visible))
    };
};

function mapStateToProps(state, ownProps) {

    return {        
        message: state.MessageReducer
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Notifier)


// WEBPACK FOOTER //
// ./src/components/Notifier/index.js